
import Vue from "vue";
import AppLayout from "@/layouts/index.vue";
import PageLoader from "@/components/navigation/PageLoader.vue";
import startCase from "lodash/fp/startCase";
import NetworkStatus from "@/modules/errors/views/NetworkStatus.vue";

export default Vue.extend({
  name: "App",

  components: { PageLoader, AppLayout, NetworkStatus },

  data: () => ({
    startCase,
    userStatusChecked: false
  }),

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.setPageTitle();
      }
    }
  },

  computed: {
    showGlobalLoader(): boolean {
      return this.$store.getters["preloader/showGlobal"];
    }
  },

  methods: {
    setPageTitle() {
      document.title = `${process.env.VUE_APP_NAME}`;
    }
  }
});
